export const getListaUnidades = state => {
  return state.listaUnidades;
};

export const getUnidadeSelecionada = state => {
  return state.unidadeSelecionada;
};

export const getListagemEnfermarias = state => {
  return state.listagemEnfermarias;
};

export const getEnfermariaSelecionada = state => {
  return state.enfermariaSelecionada;
};

export const getFiltroCodEnfermaria = state => {
  return state.filtroCodEnfermaria;
};